const config = require('../config'); const apiConfig = require('../api-config');
const apiFactory = require('../resources/investments/api-factory');
const serviceFactory = require('../resources/investments/service-factory');

function addRoutes({ requestHandler } = {}) {
  const api = apiFactory({
    requestHandler,
    baseUrl: `${config.baseUrl}/investmentidea/${apiConfig.apiversion}/`
  });

  const service = serviceFactory({ api });
  const p = '[{keys:metaData}].';

  return app => app
      .match(`${p}getFilterInvestmentData[{keys:base64Assets}][{keys:base64Actions}][{keys:cache}]`, requests => Promise.all(
        requests.map(({ req, res }) =>
          service.getInvestmentsFilterData(req.params)
            .then(response => res.value(response))
            .catch(res.error)
        )))
      .match(`${p}investmentFilter.getAssetClass[{keys:cache}]`, requests => Promise.all(
        requests.map(({ req, res }) =>
          service.getAssetNames(req.params)
            .then(response => res.value(response))
            .catch(res.error)
        )))
      .match(`${p}investmentIdeas.getArticle[{keys:articleId}][{keys:cache}]`, requests => Promise.all(
        requests.map(({ req, res }) =>
          service.getArticle(req.params)
          .then(response => res.value(response))
          .catch(res.error)
      )))
      .match(`${p}investmentIdeas.searchInvestmentIdeas[{keys:text}]`, requests => Promise.all(
        requests.map(({ req, res }) =>
          service.searchInvestmentIdeas(req.params)
          .then(response => res.value(response))
          .catch(res.error)
      )))
  }

module.exports = addRoutes;
